import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  connectFirestoreEmulator,
  getFirestore,
  setLogLevel,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import config from "./config/config.json";

// Initialize Firebase
const firebaseApp = initializeApp(config.firebaseConfig);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

// Set up log level:
if (config.firebaseLogLevel === "debug") {
  setLogLevel("debug");
}

// Connect to emulator (only in development and if enabled in config)
if (!!config.useFirebaseEmulator && window.location.hostname === "localhost") {
  connectFirestoreEmulator(firestore, "localhost", 8080);
}

export { auth, firebaseApp, firestore, storage };
